/* eslint-disable @next/next/no-img-element */
import { Button, Table } from "antd";
import React, { useState } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "@buddieshr/styles/components/comparisonTable.module.scss";
import LogoApp from "./app/logoApp";

const ComparisonTable = ({
  features,
  competitorName,
  competitorLogoUrl,
  app,
}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div>
          <h2 className={styles.title}>
            {t("compareFeatureTitle", { name: competitorName })}
          </h2>
          <div className={styles.subtitle}>{t("compareFeatureSubtitle")}</div>
        </div>
        {!show && <div className={styles.opaque}></div>}
        <Table
          className={`${styles.table} ${show ? styles.show : styles.hide} `}
          size="large"
          dataSource={features}
          pagination={false}
          columns={[
            {
              title: "",
              key: "name",
              dataIndex: "name",
              render: (name) => <span className={styles.name}>{t(name)}</span>,
            },
            {
              title: (
                <div className={styles.center}>
                  {competitorLogoUrl ? (
                    <img
                      src={competitorLogoUrl}
                      alt={`logo ${competitorName}`}
                      className={`${styles.competitorLogo}`}
                    />
                  ) : (
                    <div className={styles.bold} style={{ fontSize: "20px" }}>
                      {competitorName}
                    </div>
                  )}
                </div>
              ),
              key: "self",
              dataIndex: "self",
              className: styles.center,
              render: (self) =>
                self === true ? (
                  <span className={styles.check}>
                    <CheckCircleOutlined className={styles.checkIcon} />
                  </span>
                ) : self === false ? (
                  <span className={styles.uncheck}>
                    <CloseCircleOutlined className={styles.uncheckIcon} />
                  </span>
                ) : (
                  <span className={styles.content}>{t(self)}</span>
                ),
            },
            {
              title: (
                <div className={styles.logo}>
                  <LogoApp
                    app={app}
                    removeBack
                    withText
                    removeByBuddies
                  />
                </div>
              ),
              key: app.slug,
              dataIndex: app.slug,
              className: styles.center,
              render: (self) =>
                self === true ? (
                  <span className={styles.check}>
                    <CheckCircleOutlined className={styles.checkIcon} />
                  </span>
                ) : self === false ? (
                  <span className={styles.uncheck}>
                    <CloseCircleOutlined className={styles.uncheckIcon} />
                  </span>
                ) : (
                  <span className={styles.content}>{t(self)}</span>
                ),
            },
          ]}
        />
        <div
          className={`${styles.center} ${styles.compareShow} ${
            show ? styles.compareShowShow : ""
          }`}
        >
          <Button
            size="large"
            type="primary"
            onClick={() => {
              setShow(!show);
            }}
            style={{
              margin: "auto",
            }}
          >
            {show ? t("showLessComparison") : t("showMoreComparison")}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ComparisonTable;
